import { Component, OnInit, OnDestroy, Injector, Renderer2 } from '@angular/core';
import { LoopBackConfig, LoopBackAuth, UserData, UserDataApi, ConfigurationApi } from '../assets/js/lb-sdk';
import { environment } from '../environments/environment';
import { ProductsService, DiscountsService } from './services';
import { HasRolePipe } from './pipes/has-role.pipe';
import { USER_ROLES, SYSTEM, STORAGE_LOCATIONS } from './enums';
import { Router, NavigationStart } from '@angular/router';
import { TermsAndConditionsAcceptComponent } from './pages/administration/terms-and-conditions/terms-and-conditions-accept/terms-and-conditions-accept.component';
import { BsModalService } from 'ngx-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';


interface Services {
  [key: string]: {
    provide: any,
    deps: any[],
    useClass?: any
  }
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  bodyClasses = 'skin-blue layout-top-nav';
  body: HTMLBodyElement = document.getElementsByTagName('body')[0];

  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;

  subscriptions: Subscription[] = [];

  connectionStatusMessage: string;
  connectionStatus: string;
  value: string = 'fsdsfsdfdfdfsdf';
  constructor(
    private loopBackAuth: LoopBackAuth,
    private productService: ProductsService,
    private discountService: DiscountsService,
    private configurationApi: ConfigurationApi,
    private hasRole: HasRolePipe,
    private router: Router,
    private renderer: Renderer2,
    private userDataApi: UserDataApi,
    private modalService: BsModalService,
    private toast: ToastrService
  ) {
    LoopBackConfig.setBaseURL(environment.api);
    LoopBackConfig.filterOnUrl();
    LoopBackConfig.setApiVersion(environment.version);
    if (this.getUser()) {
      var proceed = (accepted) => {
        if (!accepted) {
          this.userDataApi
            .logout()
            .subscribe(() => {
              this.loopBackAuth.clear();
              localStorage.removeItem('orders');
              this.router.navigateByUrl('/login');
            });
        } else {
          this.productService.loadProductTypes();
          if (
            this.hasRole.transform(this.getUser().roles, USER_ROLES.GENERAL_MERCHANT, '>=') &&
            this.hasRole.transform(this.getUser().roles, USER_ROLES.AUH, '<')
          ) {
            // DO SOMETHING IF MERCHANT
            this.discountService.loadDiscounts();
          }
          if (this.hasRole.transform(this.getUser().roles, USER_ROLES.AUH, 'between', USER_ROLES.BROKER)) {
            // DO SOMETHING IF AGENT
            this.discountService.loadDiscounts();
          }
          this.configurationApi
            .buckets()
            .subscribe((data) => {
              STORAGE_LOCATIONS.PRODUCT_IMAGES = (data || [])
                .filter(config => (config.name === 'PRODUCT_IMAGES'))
                .map(config => config.value)[0];
              STORAGE_LOCATIONS.BANK_TRANSACTIONS = (data || [])
                .filter(config => (config.name === 'BANK_TRANSACTION'))
                .map(config => config.value)[0];
              STORAGE_LOCATIONS.TERMS_AND_CONDITIONS = (data || [])
                .filter(config => (config.name === 'TERMS_AND_CONDITIONS'))
                .map(config => config.value)[0];
              STORAGE_LOCATIONS.COMMISSION_UPLOADS = (data || [])
                .filter(config => (config.name === 'COMMISSION_UPLOAD'))
                .map(config => config.value)[0];
              console.log(STORAGE_LOCATIONS);
            }, (error) => {
              toast.error('An error occured while fetching storage configurations. Try to reload the page or contact admin if error persist.', 'Assets Error');
            });
        }
      };
      if (this.getUser().termsAccepted) {
        proceed(true);
      } else {
        this.terms({
          accepted: false,
        }, proceed.bind(this));
      }
    }
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          // LIST PUBLIC EVENTS
          if ([
            '/',
            '/login',
            '/forgot-password',
            '/reset-password',
            '/logout',
            '/register',
            '/verified',
            '/404',
            '/401'
          ].indexOf(event.url) >= 0 && !this.getUser()) {
            this.renderer.removeClass(document.body, 'sidebar-mini');
            this.renderer.removeClass(document.body, 'sidebar-collapse');
          } else {
            this.renderer.addClass(document.body, 'sidebar-mini');
          }
        }
      });
  }

  terms(data, next): void {
    const createModal = this.modalService
      .show(TermsAndConditionsAcceptComponent, {
        initialState: { data }
      });
    const subscription = this.modalService.onHidden
      .subscribe(() => {
        if (createModal.content) {
          if (createModal.content.result) {
            this.userDataApi.patchAttributes(this.getUser().id, {
              termsAccepted: true
            }).subscribe(user => {
              this.loopBackAuth.setUser({
                ...this.getUser(),
                ...user
              });
              console.log(this.getUser());
            });
            next(true);
          } else {
            next(false);
          }
        }
        subscription.unsubscribe();
      });
  }

  ngOnInit() {
    // add the the body classes
    this.body.classList.add('skin-blue');
    // this.body.classList.add('layout-top-nav');

    /**
    * Get the online/offline status from browser window
    */
    this.onlineEvent = Observable.fromEvent(window, 'online');
    this.offlineEvent = Observable.fromEvent(window, 'offline');

    this.subscriptions.push(this.onlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Back online';
      this.connectionStatus = 'online';
      setTimeout(() => {
        this.connectionStatusMessage = undefined;
        this.connectionStatus = undefined;
      }, 1500);
    }));

    this.subscriptions.push(this.offlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Connection lost! You are not connected to internet.';
      this.connectionStatus = 'offline';
    }));
  }

  ngOnDestroy() {
    // remove the the body classes
    this.body.classList.remove('skin-blue');
    // this.body.classList.remove('layout-top-nav');

    /**
    * Unsubscribe all subscriptions to avoid memory leak
    */
    this.subscriptions.forEach(subscription => subscription.unsubscribe());

  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }
}
